<template>
    <v-container>
        <v-layout  wrap >
            <v-row no-gutters>
                <v-col cols="12">              
                    <rates-settings />
                </v-col>
            </v-row>
        </v-layout>
    </v-container> 
</template>

<script>

import RatesSettings from '@/components/RatesSettings'

export default {
    components: {
        RatesSettings,
    }
}
</script>